import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import { CampaignBlock, HeroSection, Ticker } from '../components/HeroBlocks';
import { ModulesSection, GuidesSection, ManeuversSection, MagazineSection } from '../components/ContentSections';
import { CompetencesSection, EnquetesSection, SideInfoSection, ParcoursSection } from '../components/InfoSections';
import { FutureStudentSection, StatsBigSection, MobilitiesSection, NewsletterSection, FinalCTA, Footer } from '../components/FooterBlocks';
import PortailsProSection from '../components/PortailsProSection';
import PasserelleMotoSection from '../components/PasserelleMotoSection';
import AnnuaireHomeSection from '../components/AnnuaireHomeSection';
import NouveauteCoursSection from '../components/NouveauteCoursSection';
import UneMagazineHomeSection from '../components/UneMagazineHomeSection';
import PremierDepartHomeSection from '../components/PremierDepartHomeSection';
import ShortsAnnounceBanner from '../components/ShortsAnnounceBanner';
import FeaturedDemosSection from '../components/FeaturedDemosSection';
import ActuStoriesCarousel from '../components/ActuStoriesCarousel';
import { useAuth } from '../context/AuthContext';

export default function HomePage() {
  const { user, loading, openLogin, openRegister } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const skipRedirect = params.get('public') === '1';

  // 1) Ouvre la modale d'auth si ?login=1 (venant de /rejoindre par exemple)
  //    ?mode=signup pour ouvrir directement sur inscription, sinon connexion.
  //    ?next=/xxx pour rediriger automatiquement vers cette URL après auth.
  useEffect(() => {
    if (loading || user) return; // Déjà connecté ou en cours de chargement → pas de modale
    const loginParam = params.get('login');
    if (loginParam !== '1') return;
    const mode = params.get('mode') || 'login';
    const next = params.get('next');
    if (next) {
      // Sera lu par AuthContext.login/register après succès pour rediriger
      try { localStorage.setItem('cv_auth_next', next); } catch (_) { /* silent */ }
    }
    if (mode === 'signup') openRegister(); else openLogin();
  }, [loading, user, params, openLogin, openRegister]);

  // Auto-redirect logged-in users to their dedicated dashboard.
  // Bypass via ?public=1 (used by "Accueil public" link in user menu).
  useEffect(() => {
    if (loading || skipRedirect) return;
    // Priorité au retour "next" (rattachement enseignant après login/register)
    try {
      const nextUrl = localStorage.getItem('cv_auth_next');
      if (nextUrl && user) {
        localStorage.removeItem('cv_auth_next');
        navigate(nextUrl, { replace: true });
        return;
      }
    } catch (_) { /* silent */ }
    if (user?.is_admin) {
      navigate('/admin', { replace: true });
    } else if (user?.role === 'secretaire') {
      navigate('/secretariat', { replace: true });
    } else if (user?.role === 'enseignant') {
      navigate('/enseignant/dashboard', { replace: true });
    } else if (user?.role === 'eleve') {
      navigate('/eleve/dashboard', { replace: true });
    }
  }, [user, loading, skipRedirect, navigate]);

  return (
    <div className="App min-h-screen bg-[#0a0a0b] text-white">
      <Header />
      <CampaignBlock />
      <HeroSection />
      <UneMagazineHomeSection />
      <ShortsAnnounceBanner />
      <NouveauteCoursSection />
      <PremierDepartHomeSection />
      <FeaturedDemosSection variant="home" />
      <ActuStoriesCarousel
        mode="public"
        title="L'Actu & le fun de la conduite"
        subtitle="Citations, faits officiels de la sécurité routière, défis du jour, actu auto·moto·sport méca — un carrousel qui bouge tous les jours."
      />
      <Ticker />
      <PortailsProSection />
      <ModulesSection />
      <GuidesSection />
      <ManeuversSection />
      <CompetencesSection />
      <MagazineSection />
      <EnquetesSection />
      <SideInfoSection />
      <ParcoursSection />
      <AnnuaireHomeSection />
      <PasserelleMotoSection />
      <FutureStudentSection />
      <StatsBigSection />
      <MobilitiesSection />
      <NewsletterSection />
      <FinalCTA />
      <Footer />
    </div>
  );
}
